import { Breakpoints, DEFAULT_DISTANCE_BETWEEN_BREAKPOINTS, breakpoints } from '@/assets/themes/default/breakpoints';

import { useWindowDimensions } from './useWindowDimensions';

export const useBreakpoints = () => {
  const { width } = useWindowDimensions();

  return {
    down: (key: keyof Breakpoints) => width < breakpoints[key],
    up: (key: keyof Breakpoints) => breakpoints[key] - DEFAULT_DISTANCE_BETWEEN_BREAKPOINTS / 100 < width
  };
};
